import React, { Fragment, useState, useEffect } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { FC } from 'react';
import Checkbox from 'shared/Checkbox/Checkbox';

// DEMO DATA
const typeOfProperty = [
  {
    id: 1,
    name: 'Apartment',
    description: '',
    checked: true,
  },
  {
    id: 2,
    name: 'House',
    description: '',
    checked: true,
  },
  {
    id: 3,
    name: 'Site',
    description: '',
    checked: false,
  },
];

export interface PropertyTypeSelectProps {
  onChange?: (data: any) => void;
  onChangeParent?: any;
  fieldClassName?: string;
  types?: Array<any>;
  //   Provider {
  //     id: number,
  //     title: string,
  // }
}

const PropertyTypeSelect: FC<PropertyTypeSelectProps> = ({
  onChange,
  onChangeParent,
  fieldClassName = '[ nc-hero-field-padding ]',
  types,
}) => {
  //console.log(types?.map(({ id }) => id));
  // const [activePropertyTypes, setActivePropertyTypes] = useState(
  //   types?.map(({ id }) => id)
  // );
  // const [typeOfProperty, setTypeOfProperty] = ();
  const [activePropertyTypes, setActivePropertyTypes] = useState([]);

  // console.log('Rendering with types: ');
  // console.log(types);

  useEffect(() => {
    // console.log('Useeffect runs with tyoes: ');
    // console.log(types);
    // console.log(types?.map(({ id }) => id));
    /* @ts-ignore */
    setActivePropertyTypes(types?.map(({ id }) => id));
  }, [types]);

  useEffect(() => {
    onChangeParent(activePropertyTypes);
  }, [activePropertyTypes]);

  // useEffect(() => {
  //   if (!defaultValue) return;
  //   setTypeOfProperty(defaultValue);
  // }, defaultValue);

  //activePropertyTypes.forEach((element) => types[0]['name']);
  // console.log('<-------------------------------->');
  // console.log(activePropertyTypes);
  // console.log(types);

  //array.find(x => x.name === 'string 1')

  let typeOfPropertyText = '';
  if (activePropertyTypes && activePropertyTypes.length > 0) {
    /* @ts-ignore */
    // typeOfPropertyText = types
    //   ?.filter((item: any) => item.title)
    //   .map((item: any) => {
    //     return item.title;
    //   })
    //   .join(', ');

    /* @ts-ignore */
    var activeTextObjects = [];

    activePropertyTypes.forEach((element) =>
      activeTextObjects.push(types?.find((x) => x.id === element))
    );

    /* @ts-ignore */
    typeOfPropertyText = activeTextObjects
      ?.map((item: any) => {
        return item.title;
      })
      .join(', ');
  }

  // console.log('Types: ');
  // console.log(activePropertyTypes);

  // console.log('Check default checked');
  // console.log(
  //   // types?.map((item) => console.log(item.id))
  //   activePropertyTypes?.filter(
  //     /* @ts-ignore */
  //     (item) => console.log(item)
  //   )
  // );

  return (
    <Popover className='flex relative [ nc-flex-1 ]'>
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex text-left w-full flex-shrink-0 items-center ${fieldClassName} space-x-3 focus:outline-none cursor-pointer ${
              open ? 'nc-hero-field-focused' : ''
            }`}
          >
            <div className='text-neutral-300 dark:text-neutral-400'>
              <svg
                className='nc-icon-field nc-icon-field-2'
                width='24'
                height='24'
                fill='none'
                viewBox='0 0 24 24'
              >
                <path
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                  d='M6.75024 19.2502H17.2502C18.3548 19.2502 19.2502 18.3548 19.2502 17.2502V9.75025L12.0002 4.75024L4.75024 9.75025V17.2502C4.75024 18.3548 5.64568 19.2502 6.75024 19.2502Z'
                ></path>
                <path
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='1.5'
                  d='M9.74963 15.7493C9.74963 14.6447 10.6451 13.7493 11.7496 13.7493H12.2496C13.3542 13.7493 14.2496 14.6447 14.2496 15.7493V19.2493H9.74963V15.7493Z'
                ></path>
              </svg>
            </div>
            <div className='flex-1'>
              <span className='block xl:text-lg font-semibold overflow-hidden'>
                <span className='line-clamp-1'>
                  {typeOfPropertyText || `Type`}
                </span>
              </span>
              <span className='block mt-1 text-sm text-neutral-400 leading-none font-light '>
                Property type
              </span>
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-200'
            enterFrom='opacity-0 translate-y-1'
            enterTo='opacity-100 translate-y-0'
            leave='transition ease-in duration-150'
            leaveFrom='opacity-100 translate-y-0'
            leaveTo='opacity-0 translate-y-1'
          >
            <Popover.Panel className='absolute left-0 z-10 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl'>
              <div className=''>
                <div className='relative flex flex-col space-y-5'>
                  {types?.map((item, index: number) => (
                    <div key={item.id} className=''>
                      <Checkbox
                        name={item.title}
                        label={item.title}
                        /* @ts-ignore */
                        defaultChecked={
                          activePropertyTypes?.filter(function (val) {
                            return val === index + 1;
                          }).length > 0

                          // activePropertyTypes?.filter(
                          // /* @ts-ignore */
                          // (item) => item === index + 1
                          // )
                        }
                        onChange={(e) => {
                          const itemId = item.id;
                          if (e === true) {
                            //console.log(index);
                            // console.log(
                            //   activePropertyTypes?.filter(
                            //     /* @ts-ignore */
                            //     (item) => item === index + 1
                            //   )
                            // );

                            // console.log(
                            //   activePropertyTypes?.filter(function (val) {
                            //     return val === index + 1;
                            //   }).length > 0
                            // );

                            //console.log(item.id);
                            //  setActivePropertyTypes({...activePropertyTypes, e});
                            // xxxsetActivePropertyTypes(a => a + 1);
                            // setActivePropertyTypes((prevState) => ({
                            //   prevState.counter + e
                            // }));
                            //onChangeParent(item.id);
                            // setActivePropertyTypes(
                            //   activePropertyTypes?.push(e)
                            // );

                            /* @ts-ignore */
                            // setActivePropertyTypes((prevState) => ({
                            //   ...prevState,
                            //   itemId,
                            // }));

                            setActivePropertyTypes((prevState: any) => [
                              ...prevState,
                              itemId,
                            ]);
                          } else if (e === false && activePropertyTypes) {
                            //console.log(item.id);
                            setActivePropertyTypes(
                              activePropertyTypes?.filter(
                                (item) => item !== itemId
                              )
                            );
                            // onChangeParent(item.id);
                          }
                        }}
                      />
                    </div>
                  ))}
                  {/* {tabs.map((tab) => {
          const active = tab === tabActive;
          return (
              onClick={() => setTabActive(tab)}
              key={tab}
          );
        })} */}
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default PropertyTypeSelect;
